// extracted by mini-css-extract-plugin
export var banner = "_kb-0";
export var settingRow = "_kb-2";
export var titleIcon = "_kb-1";